export default __webpack_public_path__ + "static/media/FundoSatelite.3aade5fe.jpg";